import React, { useMemo } from 'react';
import {
  FaBriefcase, FaBuilding, FaFileAlt
} from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';
import { useDepartments } from '../hooks/useDropdownData';

const DesignationPage = () => {
  const { departments, loading: loadingDepartments } = useDepartments();

  const crudConfig = {
    baseUrl: process.env.REACT_APP_BASE_URL || '',
    endpoints: {
      fetch: '/master/getDesignation',
      save: '/master/saveDesignation',
      update: '/master/updateDesignation',
      delete: '/master/deletDesignation'
    },
    entityName: 'Designation',
    initialFormState: {
      exName: '',
      exDescription: '',
      department: '',
    },
    validateForm: (form) => {
      const errors = {};
      if (!form.exName) errors.exName = 'Designation Name is required.';
      if (!form.department) errors.department = 'Department is required.';
      return errors;
    }
  };

  const formFields = useMemo(() => [
    { name: 'exName', label: 'Designation Name', icon: FaBriefcase, required: true },
    { name: 'exDescription', label: 'Description', icon: FaFileAlt, as: 'textarea', rows: 3, fullWidth: true },
    {
      name: 'department',
      label: 'Department',
      icon: FaBuilding,
      as: 'select',
      required: true,
      options: [
        { value: '', label: loadingDepartments ? 'Loading...' : 'Select Department' },
        ...departments.map(d => ({ value: d.id, label: d.exDepartmentName }))
      ],
      loading: loadingDepartments,
    },
  ], [departments, loadingDepartments]);

  const tableColumns = [
    { key: 'exName', label: 'Name', sortable: true },
    { key: 'exDescription', label: 'Description' },
    {
      key: 'exDepartmentId',
      label: 'Department',
      sortable: true,
      render: (item) => {
        // Find department name from the list
        const department = departments.find(d => d.id === item.exDepartmentId);
        return department ? department.exDepartmentName : 'N/A';
      }
    },
  ];

  const csvHeaders = [
    { key: 'exName', label: 'Name' },
    { key: 'exDescription', label: 'Description' },
    { key: 'exDepartmentId', label: 'Department', render: (item) => {
      const department = departments.find(d => d.id === item.exDepartmentId);
      return department ? department.exDepartmentName : 'N/A';
    }},
    { key: 'exIsActive', label: 'Status', render: (item) => 'Active' }
  ];

  const transformPayload = (form, editId, userId) => {
    return {
      id: editId,
      department: parseInt(form.department, 10),
      exName: form.exName,
      exDescription: form.exDescription,
      exIsActive: true, // Always set to active
      user: userId,
    };
  };

  const transformToForm = (item) => ({
    exName: item.exName || '',
    exDescription: item.exDescription || '',
    department: item.exDepartmentId?.toString() || '',
  });

  const getViewFields = (item) => item ? [
    { label: 'Designation Name', value: item.exName, icon: FaBriefcase },
    { label: 'Department', value: departments.find(d => d.id === item.exDepartmentId)?.exDepartmentName || 'N/A', icon: FaBuilding },
    { label: 'Status', value: 'Active', icon: FaBriefcase },
    { label: 'Description', value: item.exDescription, icon: FaFileAlt, fullWidth: true },
  ] : [];

  return (
    <GenericCrudPage
      title="Designation"
      config={crudConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      csvHeaders={csvHeaders}
      csvFilename="designations.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
      emptyIcon={FaBriefcase}
      searchPlaceholder="Search designations, departments..."
    />
  );
};

export default DesignationPage;
